<!-- 柱状图 -->
<template>
    <div class="chart_box" id='chart_box' :style = "{ width: baseConfig.width + 'px', height: baseConfig.height + 'px',left: baseConfig.left + 'px',top: baseConfig.top + 'px'}">
        <div id="main" class="chart" ref='barChartRef' :style = "{ width: baseConfig.width + 'px', height: baseConfig.height + 'px',left: baseConfig.left + 'px',top: baseConfig.top + 'px'}"></div>
    </div>
</template>

<script>
import { getCurrentInstance,ref,onMounted,onUnmounted,watch,shallowRef,computed } from "vue";
import * as echarts from 'echarts';
import { useStore } from 'vuex';
export default {
    props: {
        index: {
            type:Number ,
            default: function () { return {} }
        },
        yearRef:{
            type: String,
            default: function () { return "2024" }
        }
    },
    setup(props) {
        const baseConfig = ref({})
        const { proxy } = getCurrentInstance();
        const store = useStore();
        const index = ref(props.index);
        const componentList = ref(computed(() => store.state.chartData.componentList));
        const project = ref(computed(() => store.state.project));
        const option = ref({})
        const danwei=ref()
        const barChartRef = shallowRef(null);
        const chartInstance = shallowRef(null);
        baseConfig.value = componentList.value[index.value].config.baseConfig
        const handleResize = () => {
            chartInstance.value.resize();
        };
        watch(() => store.state.chartData.componentList[index.value].config.options,(newVal, oldVal) => {
            //此时返回的是数组,按下标获取对应值
            console.log(newVal,'3333333');
                if(newVal){
                    chartInit()
                }
            },{ deep: true }
        ) 
        watch(() => store.state.chartData.componentList[index.value].data,(newVal, oldVal) => {
            //此时返回的是数组,按下标获取对应值
                if(newVal){
                    // console.log(newVal,'newVal')
                    chartInit()
                }
            },{ deep: true }
        ) 
        watch(() => store.state.chartData.componentList[index.value].config.baseConfig,(newVal, oldVal) => {
            //此时返回的是数组,按下标获取对应值
                if(newVal){
                    // console.log(componentList.value[index.value].config.baseConfig,'componentList.value[index.value].config.baseConfig')
                    baseConfig.value = componentList.value[index.value].config.baseConfig
                    // chartInit()
                   setTimeout(()=>{
                    handleResize()
                   })
                    // chart_box = d
                    //
                }
            },{ deep: true }
        ) 
        onMounted(() => {
            chartInstance.value = echarts.init(barChartRef.value);
            // getInfo(props.yearRef)
            chartInit() 
            window.addEventListener('resize', handleResize);
        });
        onUnmounted(() => {
            window.removeEventListener('resize', handleResize);
        });
        const chartInit = ()=>{
            console.log(componentList.value[index.value].data.echartsData)
            option.value =componentList.value[index.value].config.options

            //  循环赋值数据格式
            option.value.series[0].data =componentList.value[index.value].data.echartsData[0].valueList
            option.value.yAxis.data =componentList.value[index.value].data.echartsData[0].nameList
            option.value.xAxis.data =componentList.value[index.value].data.echartsData[0].nameList
            console.log(option.value,"option.value")

            chartInstance.value.setOption(option.value);
        }
    
    // store.commit("setChartData", chartData.value);
    // console.log(chartData.value,'chartData.value')
        return{
            option,
            barChartRef,
            baseConfig,

        }
    }
}
</script>

<style scoped>
.chart_box {position: relative;}
.chart {
    width: 100%;
    height: 100%;
    position: absolute;
}
</style>